import { render } from "./KTDataTable.vue?vue&type=template&id=33b7a326&ts=true"
import script from "./KTDataTable.vue?vue&type=script&lang=ts"
export * from "./KTDataTable.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__